import Vue from 'vue'
import Vuex from 'vuex'

// import app from './modules/app'

import user from './modules/user'
import global from './modules/global'
import mapping from './modules/mapping'
import menu from './modules/menu'
import getters from './getters'



Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    global,
    mapping,
    menu
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js